// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-modal__content{height:304px}.w-modal .switch-left-enter-active,.w-modal .switch-left-leave-active,.w-modal .switch-right-enter-active,.w-modal .switch-right-leave-active{transition:all .3s ease-in-out}.w-modal .switch-left-leave-to,.w-modal .switch-right-enter{transform:translateX(-100%);opacity:0}.w-modal .switch-left-enter,.w-modal .switch-right-leave-to{transform:translateX(100%);opacity:0}@media screen and (max-width:600px){.w-modal__content{height:100%}}", ""]);
// Exports
module.exports = exports;
